import script from "./grtc-video.vue?vue&type=script&setup=true&lang=js"
export * from "./grtc-video.vue?vue&type=script&setup=true&lang=js"

import "./grtc-video.vue?vue&type=style&index=0&id=f23b33b6&lang=css"

const __exports__ = script;

export default __exports__